import React, { useContext, useRef } from 'react'
import { OrderDown, OrderUp } from '../Icons/OrderDefined'
import intl from 'react-intl-universal'
import { LanguageContext } from '../../contexts/LanguageContext'
import { OrderInfoContext } from '../../contexts/OrderInfo'
import { OrderMarkContext } from '../../contexts/OrderMark'
import { OrderPriceContext } from '../../contexts/OrderPrice'

import {
  OrderPay
} from './OrderStyle.js'
import {
  payOrderMeals
} from './OrderFunction'

export default function OrderDefinedPotPay (props) {
  const OrderInfo = useContext(OrderInfoContext)
  const OrderMark = useContext(OrderMarkContext)
  const OrderPrice = useContext(OrderPriceContext)
  const Language = useContext(LanguageContext)
  const potPayBotton = useRef('potPayBotton')
  const OrderShoppingHeight = (window.innerHeight - 50) * 0.07 < 48 ? (window.innerHeight - 50) * 0.07 : 48
  return (
    <OrderPay className={'abs bgf pl20 pr10 pt5 w100 trans b0 lt1'} style={{ transform: props.isshow ? 'translateY(0%)' : 'translateY(150%)', paddingBottom: `${OrderShoppingHeight}px` }}>
      <ul className='lh1-8 flex fs15'>
        <li className='w50'>{intl.get('User Information')}</li>
        <li className='w10'>
          <div
            onClick={() => props.setIsshow(!props.isshow)}>
            {props.isshow ? <OrderDown /> : <OrderUp />}
          </div>
        </li>
      </ul>
      <ul className='lh1-8 flex g6d'>
        <li className='w50 tl ti1'>{intl.get('Name of patient:')}</li>
        <li className='w50 tr pr10'>
          {OrderMark.patientName}
        </li>
      </ul>
      <ul className='lh1-8 flex g6d'>
        <li className='w50 tl ti1'>
          {intl.get('Bed number:')}
        </li>
        <li className='w50 tr pr10'>
          {OrderMark.position}
        </li>
      </ul>
      <ul className='lh1-8 flex fs15 g2 pr10'>
        <li className='w50'>{intl.get('Total cost')}</li>
        <li className='w50 tr'>&yen;{OrderPrice.price.toFixed(2)}</li>
      </ul>
      <ul className={'lh1-9 flex g6d' + (OrderPrice.yyPrice === 0 ? ' hidden' : '')}>
        <li className='w75 ti1'>
          {intl.get('Meal package')}
          {
            Language.locale && Language.locale.includes('en') ? ':' : ''
          }
          {
            Language.locale && Language.locale.includes('en')
              ? (OrderPrice.isYyPot ? <div className='mt-8'>({intl.get('Pay upon discharge')})</div> : <div className='mt-8'>({intl.get('Pay now')})</div>)
              : (OrderPrice.isYyPot ? <span>({intl.get('Pay upon discharge')}):</span> : <span>({intl.get('Pay now')}):</span>)
          }
        </li>
        <li className='w25 tr pr10'>
          &yen;{OrderPrice.yyPrice.toFixed(2)}
        </li>
      </ul>
      <ul className={'lh1-9 flex g6d' + (OrderPrice.xgPrice === 0 ? ' hidden' : '')}>
        <li className='w75 tl ti1'>
          {intl.get('SmallPotDishes')}
          {
            Language.locale && Language.locale.includes('en') ? ':' : ''
          }
          {
            Language.locale && Language.locale.includes('en')
              ? (OrderPrice.isXgPot ? <div className='mt-8'>({intl.get('Pay upon discharge')})</div> : <div className='mt-8'>({intl.get('Pay now')})</div>)
              : (OrderPrice.isXgPot ? <span>({intl.get('Pay upon discharge')}):</span> : <span>({intl.get('Pay now')}):</span>)
          }
        </li>
        <li className='w25 tr pr10'>
          &yen;{OrderPrice.xgPrice.toFixed(2)}
        </li>
      </ul>
      <div className='lh1-8 tc fs21 fw9 pt10 g4f'>
        {intl.get('Payment required')}{' '}&yen;{OrderPrice.payPrice.toFixed(2)}
      </div>
      <div style={{ height: '2.42rem', marginBottom: '2.5rem' }}>
        <button id='payBottonid' className='abs clip' ref={potPayBotton}
          onClick={() => {
            payOrderMeals(potPayBotton, OrderInfo, OrderPrice, OrderMark, Language, props.setIsshow, props.setShowModal, props.setModalInfo, props.history, props.advanceDay)
          }}
        />
        <label htmlFor='payBottonid' className='h100 db w58 auto rds6 rel comfirm-pay tc gf lt2' style={{ lineHeight: '2.42rem' }}>
          {intl.get('Confirmation of payment')}
        </label>
      </div>
    </OrderPay>
  )
}
